module.exports = __webpack_public_path__ + "7979a6d8.svg";